import React, { useEffect } from 'react';
import classnames from 'classnames';
import TabContext, { inputOptions } from './context';
import { askSDK } from '../../../../utils/index';

export type inputProps = {
  className?: string;
  tabIndex: number; // 当前索引
  maxLength?: number; // 最大可输入
  value?: number | string; // 输入框的值
  name?: string; // 输入的字段名称
  defaultValue?: number | string; // 输入框的值
  unavailableText?: string; // 不可输入的字符
  style?: object; // 样式
  width?: any; // 宽度
}

const defaultProps: inputProps = {
  className: '',
  tabIndex: -1,
  style: {},
  defaultValue: '',
}

export default function TabInput(props: inputProps = defaultProps) {
  props = { ...defaultProps, ...props };

  const {
    className = '',
    defaultValue,
    name = '',
    maxLength,
    tabIndex,
    unavailableText: text,
    width,
    ...rest
  } = props;
  useEffect(() => {
    // 阻止原生的键盘弹出
    // (document.activeElement as any).blur();
    askSDK('softInputMode', {
      enable: 0,
    });
    return () => {
      askSDK('softInputMode', {
        enable: 1,
      });
    }
  }, []);
  const buttonRef = React.useRef(null);
  // 上下文
  const contextValue = React.useContext(TabContext);

  // 不可用字符
  const unavailableText = props.unavailableText || contextValue.unavailableText;
  // 创建匹配正则
  const regRef = React.useRef<RegExp>(new RegExp(`[${unavailableText}]`, 'igm'));
  // 获取焦点
  function onFocus(element: HTMLInputElement): void {
    element.setAttribute('readOnly', 'false');

    // 全选
    // setTimeout(() => {
    //   // element.select();
    //   element.selectionStart = 0;
    //   element.selectionEnd = element!.value?.length;
    // }, 1)
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    if (isAndroid) {
        element.select();
    } else {
      element.selectionStart = 0;
      element.selectionEnd = element!.value?.length;
    }
    // 调用父组件获取焦点
    contextValue?.onFocus({
      name,
      value: element.value,
      unavailableText,
      element,
    });
  }

  // 失去焦点
  function onBlur(element: HTMLInputElement): void {
    // askSDK('softInputMode', {
    //   enable: 1,
    // });

    // 调用父组件获取焦点
    contextValue?.onBlur({
      name,
      value: element.value,
      element,
    });
  }
  // 输入框点击
  function onClick(event: any): void {
    const element = event.target;
    event.preventDefault();
    event.stopPropagation();
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    if (isAndroid) {
        element.select();
    } else {
      element.selectionStart = 0;
      element.selectionEnd = element!.value?.length;
    }
    // 全选
  }

  // 输入值的改变
  function onChange(element: HTMLInputElement): void {
    // 如果存在禁止输入的字符需要replace为空
    // if (unavailableText) {
    //   element.value = element.value.replace(regRef.current, '');
    // }

    // // 调用父组件改变输入值
    // contextValue?.onChange({
    //   name,
    //   value: element.value,
    //   element,
    // });
  }

  React.useLayoutEffect(() => {
    contextValue.createRef(buttonRef.current, tabIndex);
  }, []);

  // 是否受控
  let valueProps: any = { defaultValue };
  if (props.value) {
    valueProps = { value: props.value };
  }


  return (
    <div
      className={classnames({ 'tab-input-box': true, [className]: !!className })}
    >
      <input
        autoComplete="off"
        className={classnames({ 'tab-input': true, border: contextValue.border, [className]: !!className })}
        ref={buttonRef}
        tabIndex={tabIndex}
        name={name}
        readOnly="readOnly"
        onFocus={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onFocus(event.target)
        }
        }
        onClick={(event) => onClick(event)}
        onBlur={(event) => onBlur(event.target)}
        onChange={(event) => onChange(event.target)}
        onSelect={() => { return false }}
        onCopy={() => { return false }}
        onCopyCapture={(event) => { event.preventDefault() }}
        maxLength={maxLength || contextValue.maxLength}
        {...rest}
        {...valueProps}
        style={{ width: `${width}px` }}

      />
    </div>
  )
}
